<template>
  <form @submit.prevent="save">
    <div class="order-operations-modal modal-card" style="width: 90vw">
      <header class="modal-card-head">
        <p class="modal-card-title has-text-weight-bold">
          Select Asset
        </p>
      </header>
      <section class="modal-card-body" ref="body">
        <order-operations-modal-map
          :order="order"
          :operation="operation"
          :selected.sync="selectedAsset"
          :disabled="disabled"
          :height="mapHeight"
          :mode.sync="mapMode"
          :address="address"
          :map-config="mapConfig"
          :filter-asset-types="filterAssetTypes"
          @coordinateAddress="coordinateAddress"
          @click-map="event => locationSelected = event ? event.latlng : null"
          @locationfound="event => locationSelected = event ? event.latlng : null"
          ref="orderOperationsModalMap"
        >
          <template #mapDetailHeaderButtons="{ close }">
            <b-button size="is-small" @click="close('list')">CLOSE</b-button>
          </template>
        </order-operations-modal-map>
      </section>
      <footer class="modal-card-foot">
        <b-button @click="$parent.close()">CANCEL</b-button>
        <b-button
          type="is-info"
          :loading="selectingLocation"
          :disabled="!selectedAsset && !locationSelected"
          @click="selectLocation"
          v-if="hasSelectLocation"
        >
          SELECT LOCATION
        </b-button>
        <b-button
          :id="`${isSelectedValid ? 'select_asset' : ''}`"
          type="is-info"
          :loading="selectingAsset"
          :disabled="(order && order.editable != undefined && !order.editable) || !isSelectedValid"
          @click="select"
          v-if="!disabled && canSelectAsset"
          >SELECT ASSET</b-button
        >
      </footer>
    </div>
  </form>
</template>

<script>
import OrderOperationsModalMap from "./OrderOperationsModalMap";
import { CodeService } from "@/services/code.service";
import { JsonDenormalizer } from "@/helpers/JsonDenormalizer";
import { correctFloat } from 'highcharts';

export default {
  props: {
    order: {
      type: Object,
      // required: true
    },
    operation: {
      type: Object,
      // required: true
    },
    operationCodeIds: {
      type: Array,
      default: () => []
    },
    filterCodeIds: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    address: {},
    hasSelectLocation: {
      type: Boolean,
      default: false
    },
    location: {
      type: Object
    },
  },
  components: {
    OrderOperationsModalMap
  },
  data: () => ({
    codeService: CodeService,
    mapMode: "list",
    selectedAsset: null,
    validAssetTypes: [],
    filterAssetTypes: [],
    mapHeight: 0,
    locationSelected: null,
    selectingAsset: false,
    selectingLocation: false,
    mapConfig: {}
  }),
  computed: {
    isSelectedValid() {
      return (
        // (!this.selectedAsset) ||
        this.selectedAsset &&
        this.selectedAsset.code &&
        this.validAssetTypes.includes(this.selectedAsset.code.id)
      );
    },
    canSelectAsset() {
      return (
        ! this.disabled
        && (
          // REMINDER: on orders/create page, there is sometimes a dummy operation created
          // with the last selected asset - so we can't assume that an operation exists
          // on the server purely because an operation object was passed as a prop.
          ( (! this.order || ! this.order.id) && ( ! this.operation || ! this.operation.id))
          ||
          (this.order && this.$store.state.Auth.user.firmId == this.order.firm_id)
          ||
          (this.operation && this.operation.status && this.operation.status.toUpperCase() == 'DRAFT')
        )
      );
    }
  },
  created() {
    this.selectedAsset = this.operation ? this.operation.asset : null;
    this.fetchValidAssetTypes();
    this.fetchFilterAssetTypes();
    this.mapConfig = {
      hasLocateControl: this.hasSelectLocation,
      markerOnClick: this.hasSelectLocation
    };
    if (this.location && !this.selectedAsset) {
      this.mapConfig.center = this.location;
    }
  },
  mounted() {
    this.$nextTick(() => {
      // modal body height - modal body top/bottom padding
      this.mapHeight = this.$refs.body.clientHeight - 40;
    });

    if (this.location && !this.selectedAsset) {
      console.log('set loc');
      this.$refs.orderOperationsModalMap.setLocation(this.location, true);
    }
  },
  methods: {
    coordinateAddress(coordinateAddress) {
      alert();
      console.log(coordinateAddress);
    },
    async getAssetLocation(asset) {
      const coordinates = {
        lat: parseFloat(asset.assetNodes[0].latitude),
        lng: parseFloat(asset.assetNodes[0].longitude)
      };
      const results = await this.getAddress(coordinates) || [];
      let address = results.find(
        (r) => !!(r.types || []).find((t) => t == "street_address")
      );
      address = address
        ? address.formatted_address
        : results.length
        ? results[0].formatted_address
        : null;
      return {
        address,
        coordinates,
      };
    },
    async select() {
      this.selectingAsset = true;

      // const coordinates = {
      //   lat: parseFloat(this.selectedAsset.assetNodes[0].latitude),
      //   lng: parseFloat(this.selectedAsset.assetNodes[0].longitude)
      // };
      // const results = await this.getAddress(coordinates);
      // let address = results.find(
      //   (r) => !!(r.types || []).find((t) => t == "street_address")
      // );
      // address = address
      //   ? address.formatted_address
      //   : results.length
      //   ? results[0].formatted_address
      //   : null;
      // this.$emit("select-location", {
      //   address,
      //   coordinates
      // });
      const location = await this.getAssetLocation(this.selectedAsset);
      this.$emit("select-location", location);
      this.$emit("select", this.selectedAsset);

      this.selectingAsset = false;
      this.$parent.close();
    },
    async fetchValidAssetTypes() {
      const codes = await this.codeService
        .chained({
          ids: this.operationCodeIds,
          type: "ASSET",
          contract_id: this.order.contract_id || undefined,
        })
        .then(response => JsonDenormalizer.denormalize(response));

      this.validAssetTypes = codes.map(code => code.id);
    },
    async fetchFilterAssetTypes() {
      if (this.filterCodeIds.length == 0) return;
      const codes = await this.codeService
        .chained({
          ids: this.filterCodeIds,
          type: "ASSET",
          contract_id: this.order.contract_id || undefined,
        })
        .then(response => JsonDenormalizer.denormalize(response));

      this.filterAssetTypes = codes.map(code => code.id);
    },
    async selectLocation() {
      if (!this.selectedAsset && !this.locationSelected) return;

      this.selectingLocation = true;

      if (this.selectedAsset) {
        const location = await this.getAssetLocation(this.selectedAsset);
        this.$emit("select-location", location);
        this.$emit("select-location-asset", this.selectedAsset);
      } else {
        const results = await this.getAddress(this.locationSelected);
        this.$emit("select-location", {
          address: results.length ? results[0].formatted_address : null,
          coordinates: this.locationSelected
        });
        this.$emit("select-location-asset", null);
      }
      this.$emit("select", null);

      this.selectingLocation = false;
      this.$parent.close();
    },
    getAddress(latLng) {
      return new Promise((resolve, reject) => {
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: latLng }, (results, status) => {
          resolve(results);
        });
      });
    }
  }
};
</script>

<style scoped>
.modal-card-foot {
  justify-content: flex-end;
}
</style>



// WEBPACK FOOTER //
// src/components/Order/OrderOperationsModal.vue